// assets
import {
    IconBuildingSkyscraper, 
    IconBrandSuperhuman,
    IconHelp,
    IconBriefcase
} from '@tabler/icons';

import SecurityService from "services/SecurityService";
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const general = {
    id: 'general',
    title: 'General',
    type: 'collapse',
    children: []
};

if (SecurityService.userIsGrantedTo('companies', 'write')) {
    general.children.push({
        id: 'companies',
        title: 'Companies',
        type: 'item',
        url: '/companies',
        icon: IconBuildingSkyscraper,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('product_file', 'write')) {
    general.children.push({
        id: 'product_files',
        title: 'Product files',
        type: 'item',
        url: '/product_files',
        icon: IconBrandSuperhuman,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('carriers', 'write')) {
    general.children.push({
        id: 'carriers',
        title: 'Carriers',
        type: 'item',
        url: '/carriers',
        icon: IconBriefcase,
        breadcrumbs: false
    });
}

if (SecurityService.userIsGrantedTo('system_support', 'write')) {
    general.children.push({
        id: 'system_support',
        title: 'System support',
        type: 'item',
        url: '/system_support',
        icon: IconHelp,
        breadcrumbs: false
    });
}

export default general;
